import { SingleGridResponse } from "../../../../../pure-javascript-api/javascript-api/single-grid-request";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { JSApiPointToTiChartDataPointMapper } from "./js-api-point-to-ti-chart-point.mapper";

export class JSApiPointToUpdateTiChartDataPointMapper {
    public static map(rawData: Map<string, SingleGridResponse>, lastDataPoint: TIChartPointModel, showPreMarket: boolean, showPostMarket: boolean): Array<TIChartPointModel> {
        const updateTiDataPoints = JSApiPointToTiChartDataPointMapper.map(rawData, 0, showPreMarket, showPostMarket);
        const result: Array<TIChartPointModel> = [];
        if (!updateTiDataPoints?.length) {
            return result;
        }

        for (const dataPoint of updateTiDataPoints) {
            if (dataPoint.startTimeT == lastDataPoint.startTimeT) {
                dataPoint.xValue = lastDataPoint.xValue;
                result.push(dataPoint);
            } else if (dataPoint.startTimeT > lastDataPoint.startTimeT) {
                dataPoint.xValue = lastDataPoint.xValue + 1;

                lastDataPoint = dataPoint;

                result.push(dataPoint);
            }
        }

        return result;
    }
}